var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('crud-layout-search',{ref:"crudLayoutSearch",attrs:{"name":_vm.name,"interface":_vm.nmInterface,"id":_vm.id,"noneselect":true,"pageTable":_vm.pageTable,"row-buttons":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }